import {
	SettingKey,
} from './enums/setting-key.enum';
import Dexie, {
	IndexableType, Table,
} from 'dexie';
import {
	database,
} from '.';
import {
	HttpRequestType,
} from 'utils/http';

/**
 * Just a simple wrapper around updating settings
 * @param key - The key/id that the setting should be referenced as in the DB.
 * @param value
 */
export const updateSettings = async (key: SettingKey, value: string) =>
	await database.settings.put({
		key, value,
	});

/**
 * Resets the local database
 */
export const clearDatabase = (db: Dexie = database) => {
	return db.transaction('rw', db.tables, async () => {
		await Promise.all(db.tables.map(table => table.clear()));
	})
};

// export const addToSyncManager = async (key: SettingKey, value: any) => {
// 	await database.syncData.put({
// 		key, value,
// 	})
// 		.then(() => {
// 			console.log('aa2112');
// 			return;
// 		}).catch(() => {
// 			console.log('aa2112!!!!');
// 		});
// 	// return new Promise((resolve, reject) => {
// 	// resolve(value);
// 	// })
// };

// export const removeSyncManagerNotifications = async (id: number) => {
// 	await database.syncNotification.where('id').equals(id).delete();
// };

// export const getFromSyncManager = async (key: SettingKey, value: any) => {
// 	await database.syncData.toArray()
// 		.then((data) => {
// 			console.log('bb2112');
// 			return data;
// 		}).catch(() => {
// 			console.log('bb2112!!!!');
// 			return [];
// 		});
// 	//  return new Promise((resolve, reject) => {
// 	//    resolve(value);
// 	//  })
// };

/**
 * Updating the database with the content if a table is provided
 * It is mainly intended for use via http-client
 *
 * In order to just update a part of an object(and the value of the PK to update) use PATCH or PUT
 * POST will update and replace the whole object.
 *
 * If you only wish to update one parameter of a nested object eg:
 * parent: {
 * 		content: {
 * 			text: 'hello',
 * 		  number: 123,
 * 		},
 * }
 *
 * And you only wish to update the paramter text in parent.content, you can send this as the input:
 * {
 *   'parent.content.text': 'The new text'
 * }
 *
 * If you post a content child with just text, the whole content object will be re-written.
 *
 * @param result
 * @param table - A specific database table reference
 * @param requestType - HttpRequestType
 * @param tableId - The id in the table to delete
 */
export const upsertToDB = <T>(
	result: T | T[] | IndexableType,
	table?: Table,
	requestType?: HttpRequestType,
	tableId?: IndexableType
): Promise<IndexableType | void> => {
	return new Promise<IndexableType | void>((resolve, reject) => {
		try {
			if (table && (result || tableId)) {
				switch (requestType) {
					case HttpRequestType.DELETE:
						// It won't get here if tableId is undefined,
						// but for the IDE we need as to make it happy
						table.delete(tableId as IndexableType)
							.then(resolve)
							.catch(
								error => console.error('HttpClient.upsertToDB.delete', table.name, error));
						break;
					case HttpRequestType.POST:
					case HttpRequestType.PUT:
					case HttpRequestType.GET:
						if (Array.isArray(result)) {
							table.bulkPut(result)
								.then((id) => resolve(id))
								.catch(
									error => console.error('HttpClient.upsertToDB.bulkPut', table.name, error));
						}
						else {
							table.put(result)
								.then(id => resolve(id))
								.catch(
									error => console.error('HttpClient.upsertToDB.put', table.name, error));
						}
						break;
					case HttpRequestType.PATCH:
						const data = result as any;
						if (!tableId && !data?.id) {
							const error = 'The patch request needs a id to be defined either via' +
								' tableId in the options or as an value in the result object';
							console.error('HttpClient.upsertToDB.patch', error);
							reject(error);
							return;
						}
						table.update(tableId ? tableId : data?.id, result as any)
							.then(resolve)
							.catch(
								error => console.error('HttpClient.upsertToDB.patch', table.name, error));
						break;
					default:
						resolve();
						break;
				}
			}
			else {
				resolve();
			}
		}
		catch (error) {
			console.error('HttpClient.upsertToDB', error, result);
			reject(error);
		}
	});
}

export {
	SettingKey,
}